import qrcode from "qrcode.react";
import React from "react";
import QRcode from "qrcode.react";
export default function FamTable(props) {
  const { title, list, qr } = props;
  return (
    <>
      <h3>{title}</h3>
      <table>
        <thead>
          <tr>
            <th>Сотрудник</th>
            <th>Документ</th>
            <th>Версия</th>
            <th>Дата документа</th>
            <th width="20%">Ознакомлен</th>
            {qr && <th>Подпись</th>}
          </tr>
        </thead>
        <tbody>
          {list.map((item, idx) => {
            let dt = item.validfromdate ? new Date(item.validfromdate) : {};
            let dtFam = item.date ? new Date(item.date) : {};
            return (
              <tr key={idx}>
                <td>{item.staffname}</td>
                <td>{item.label}</td>
                <td>{item.version}</td>
                <td>{dt.toLocaleString()}</td>
                <td>
                  {item.familiarized ? "Ознакомлен" : "Не ознакомлен"}
                  {item.date && <div>{dtFam.toLocaleString()}</div>}
                </td>
                {qr && <td>{item.sign && <QRcode value={item.sign} />}</td>}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}
